import { api } from "@/redux/api";

import {
	CompanyRevenue,
	CompanyRevenueArraySchema,
	CreateCompanyRevenue,
} from "../../pages/ManageCompanyRevenue/schema/company-revenue";

export const CompanyRevenueApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getCompanyRevenues: builder.query<CompanyRevenue[], void>({
			query: () => ({
				url: "company-revenue",
				responseSchema: CompanyRevenueArraySchema,
			}),
			providesTags: ["CompanyRevenue"],
		}),
		createCompanyRevenue: builder.mutation<CompanyRevenue, CreateCompanyRevenue>({
			query: (body) => ({
				url: "company-revenue",
				method: "POST",
				body,
			}),
			invalidatesTags: ["CompanyRevenue"],
		}),
		updateCompanyRevenue: builder.mutation<CompanyRevenue, CompanyRevenue>({
			query: (body) => ({
				url: `company-revenue/${body.id}`,
				method: "PATCH",
				body,
			}),
			invalidatesTags: ["CompanyRevenue"],
		}),
		deleteCompanyRevenue: builder.mutation<CompanyRevenue[], number>({
			query: (id) => ({
				url: `company-revenue/${id}`,
				method: "DELETE",
				responseSchema: CompanyRevenueArraySchema,
			}),
			invalidatesTags: ["CompanyRevenue"],
		}),
	}),
});

export const {
	useGetCompanyRevenuesQuery,
	useCreateCompanyRevenueMutation,
	useUpdateCompanyRevenueMutation,
	useDeleteCompanyRevenueMutation,
} = CompanyRevenueApi;

export const CompanyRevenueApiReducer = CompanyRevenueApi.reducer;
export const CompanyRevenueApiMiddleware = CompanyRevenueApi.middleware;
